export default function groupEventListener(room) {
    return store => {
        room.addEventListeners({
            group_data_init: groupData => {
                store.commit('group/GROUP_INIT', groupData.data)
            }
        })
    }
}